<template>
  <div class="main-layout">
    <!-- 公告弹窗 -->
    <a-modal
      v-model:visible="noticeVisible"
      :title="notice.title"
      :closable="true"
      :mask-closable="false"
      :keyboard="false"
      class="notice-modal"
    >
      <div class="notice-content">
        <div class="notice-text">
          <p v-for="(line, index) in noticeContentLines" :key="index">{{ line }}</p>
        </div>
      </div>
      <template #footer>
        <a-button type="primary" @click="closeNotice">我知道了</a-button>
      </template>
    </a-modal>

    <!-- 顶部导航栏 -->
    <header class="header">
      <div class="logo-section">
        <img src="@/assets/logo.png" alt="Logo" class="logo" />
        <span class="site-name">天际图片</span>
      </div>
      <nav class="nav-menu">
        <a-menu mode="horizontal" v-model:selectedKeys="currentKey" @select="handleMenuSelect">
          <a-menu-item key="home">
            首页
          </a-menu-item>
          <a-menu-item key="about">
            关于我们
          </a-menu-item>
          <a-menu-item key="store">
            图片商店
          </a-menu-item>
          <a-menu-item key="contact">
            联系我们
          </a-menu-item>
        </a-menu>
      </nav>
<!--      <div class="user-section">-->
<!--        <a-button type="primary" @click="router.push('/login')">管理员登录</a-button>-->
<!--      </div>-->
    </header>

    <!-- 主要内容区 -->
    <main class="main-content">
      <div class="showcase-container">
        <div class="showcase">
          <div class="image-container" 
               v-for="(image, index) in showcaseImages" 
               :key="index"
               :style="getImageStyle(index)"
               @mouseenter="pauseAnimation"
               @mouseleave="resumeAnimation">
            <img :src="image.url" :alt="image.title" />
          </div>
        </div>
        <div class="buy-now-container">
          <a-button type="primary" class="buy-now-btn" @click="goToStore">立即购买</a-button>
        </div>
      </div>

      <!-- 关于我们部分 -->
      <div id="about-section" class="about-section">
        <div class="about-container">
          <!-- 专业团队 -->
          <div class="about-item">
            <div class="about-image">
              <img src="@/assets/team.jpg" alt="专业团队" />
            </div>
            <div class="about-content">
              <h2>专业团队</h2>
              <p>我们的团队由经验丰富的艺术家和设计师组成，确保每个作品的高质量。</p>
            </div>
          </div>
          
          <!-- 创新理念 -->
          <div class="about-item reverse">
            <div class="about-image">
              <img src="@/assets/innovation.jpg" alt="创新理念" />
            </div>
            <div class="about-content">
              <h2>创新理念</h2>
              <p>我们不断探索新的创作方式，以保持艺术作品的新鲜感与独特性。</p>
            </div>
          </div>

          <div class="about-item">
            <div class="about-image">
              <img src="@/assets/innova.jpg" alt="创新理念" />
            </div>
            <div class="about-content">
              <h2>客户至上</h2>
              <p>我们重视客户的反馈，力求在每个项目中，满足客户的期望与需求</p>
            </div>
          </div>
        </div>
      </div>

      <footer id="contact-section" class="footer">
        <div class="contact-section">
          <h2 class="contact-title">联系我们</h2>
          
          <div class="contact-icons">
            <div class="contact-item">
              <img :src="qrcode1" alt="TG" class="qr-code" />
              <span>TG咨询(白班8:00-19:00)</span>
            </div>
            <div class="contact-item">
              <img :src="qrcode2" alt="whatsApp" class="qr-code" />
              <span>whatsApp咨询(白班8:00-19:00)</span>
            </div>
            <div class="contact-item">
              <img :src="qrcode3" alt="line" class="qr-code" />
              <span>Line咨询(白班8:00-19:00)</span>
            </div>
            <div class="contact-item">
              <img :src="qrcode4" alt="TG" class="qr-code" />
              <span>TG咨询(夜班19:00-5:00)</span>
            </div>
            <div class="contact-item">
              <img :src="qrcode5" alt="whatsApp" class="qr-code" />
              <span>whatsApp咨询(夜班19:00-5:00)</span>
            </div>
            <div class="contact-item">
              <img :src="qrcode6" alt="line" class="qr-code" />
              <span>Line咨询(夜班19:00-5:00)</span>
            </div>
            <div class="contact-item">
              <img :src="qrcode7" alt="line" class="qr-code" />
              <span>tg咨询(售后客服)</span>
            </div>
            <div class="contact-item">
              <img :src="qrcode8" alt="line" class="qr-code" />
              <span>whatsApp咨询(售后客服)</span>
            </div>
            <div class="contact-item">
              <img :src="qrcode9" alt="line" class="qr-code" />
              <span>Line咨询(售后客服)</span>
            </div>

          </div>
        </div>
      </footer>
    </main>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, onUnmounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import {
  HomeOutlined,
  PictureOutlined,
  UploadOutlined,
  InfoCircleOutlined
} from '@ant-design/icons-vue'
import { getApiUrl } from '@/utils/api'

export default defineComponent({
  name: 'MainLayout',
  components: {
    HomeOutlined,
    PictureOutlined,
    UploadOutlined,
    InfoCircleOutlined
  },
  setup() {
    const router = useRouter()
    const currentKey = ref(['home'])
    const currentAngle = ref(0)
    let animationFrame = null
    const isAnimating = ref(true)

    // 引用二维码图片
    const qrcode1 = ref(require('@/assets/qrcode1.jpg'))
    const qrcode2 = ref(require('@/assets/qrcode2.jpg'))
    const qrcode3 = ref(require('@/assets/qrcode3.jpg'))
    const qrcode4 = ref(require('@/assets/qrcode4.jpg'))
    const qrcode5 = ref(require('@/assets/qrcode5.jpg'))
    const qrcode6 = ref(require('@/assets/qrcode6.jpg'))
    const qrcode7 = ref(require('@/assets/qrcode7.jpg'))
    const qrcode8 = ref(require('@/assets/qrcode8.jpg'))
    const qrcode9 = ref(require('@/assets/qrcode9.jpg'))

    // 示例图片数组
    const showcaseImages = ref([
      { url: require('@/assets/1.jpg'), title: '图片1' },
      { url: require('@/assets/2.jpg'), title: '图片2' },
      { url: require('@/assets/3.jpg'), title: '图片3' },
      { url: require('@/assets/4.jpg'), title: '图片4' },
      { url: require('@/assets/5.jpg'), title: '图片5' },
      { url: require('@/assets/6.jpg'), title: '图片6' },
      { url: require('@/assets/7.jpg'), title: '图片7' },
      { url: require('@/assets/8.jpg'), title: '图片8' },
      { url: require('@/assets/9.jpg'), title: '图片9' },
      { url: require('@/assets/10.jpg'), title: '图片10' },
      { url: require('@/assets/11.jpg'), title: '图片11' },
      { url: require('@/assets/12.jpg'), title: '图片12' },
      { url: require('@/assets/13.jpg'), title: '图片13' },
    ])

    // 公告相关状态
    const noticeVisible = ref(false)
    const notice = ref({
      title: '网站公告',
      content: '加载中...'
    })

    // 获取公告内容
    const fetchNotice = async () => {
      try {
        // 检查是否已经显示过公告
        const hasShownNotice = sessionStorage.getItem('hasShownNotice')
        if (hasShownNotice) {
          return
        }

        const response = await fetch(getApiUrl('/api/notice'), {
          credentials: 'include',
          headers: {
            'Accept': 'application/json'
          }
        })
        if (!response.ok) {
          throw new Error('获取公告失败')
        }
        const data = await response.json()
        notice.value = data
        noticeVisible.value = true // 显示公告
      } catch (error) {
        console.error('获取公告失败：', error)
        notice.value = {
          title: '网站公告',
          content: '欢迎访问天骥图片官网'
        }
      }
    }

    // 计算公告内容的行数组
    const noticeContentLines = computed(() => {
      return notice.value.content.split('\n')
    })

    const animate = () => {
      if (isAnimating.value) {
        currentAngle.value += 0.2
      }
      animationFrame = requestAnimationFrame(animate)
    }

    const pauseAnimation = () => {
      isAnimating.value = false
    }

    const resumeAnimation = () => {
      isAnimating.value = true
    }

    const getImageStyle = (index) => {
      const angle = (360 / showcaseImages.value.length) * index + currentAngle.value
      const radius = 800
      const z = Math.cos(angle * Math.PI / 180) * radius
      const x = Math.sin(angle * Math.PI / 180) * radius
      const scale = (z + radius) / (2 * radius)
      
      return {
        transform: 'translate3d(' + x + 'px, 0, ' + z + 'px) scale(' + scale + ')',
        zIndex: Math.round(z + radius)
      }
    }

    const handleMenuSelect = ({ key }) => {
      if (key === 'about') {
        document.getElementById('about-section')?.scrollIntoView({ behavior: 'smooth' })
      } else if (key === 'contact') {
        document.getElementById('contact-section')?.scrollIntoView({ behavior: 'smooth' })
      } else if (key === 'home') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      } else if (key === 'store') {
        router.push('/store')
      }
    }

    const goToStore = () => {
      router.push('/store')
    }

    const closeNotice = () => {
      noticeVisible.value = false
      // 记录已经显示过公告
      sessionStorage.setItem('hasShownNotice', 'true')
    }

    onMounted(() => {
      animate()
      fetchNotice()
    })

    onUnmounted(() => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame)
      }
    })

    return {
      currentKey,
      showcaseImages,
      getImageStyle,
      qrcode1,
      qrcode2,
      qrcode3,
      qrcode4,
      qrcode5,
      qrcode6,
      qrcode7,
      qrcode8,
      qrcode9,
      handleMenuSelect,
      router,
      noticeVisible,
      notice,
      noticeContentLines,
      closeNotice,
      pauseAnimation,
      resumeAnimation,
      goToStore
    }
  }
})
</script>

<style scoped>
.main-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #000;
  margin: 0;
  padding: 0;
  border: none;
}

body {
  margin: 0;
  padding: 0;
  background: #000;
}

.header {
  height: 64px;
  background: #000;
  box-shadow: none;
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  border: none;
  width: 100%;
}

.logo-section {
  display: flex;
  align-items: center;
  margin-right: 40px;
  padding-left: 20px;
}

.logo {
  height: 32px;
  margin-right: 12px;
}

.site-name {
  font-size: 1.2rem;
  font-weight: bold;
  color: #fff;
}

.nav-menu {
  margin-left: auto;
  margin-right: 24px;
  border: none;
  height: 64px;
  display: flex;
  align-items: center;
}

.nav-menu :deep(.ant-menu) {
  line-height: 64px;
  border: none;
  background: transparent;
  color: #fff;
  margin: 0;
  padding: 0;
  height: 64px;
}

.nav-menu :deep(.ant-menu-horizontal) {
  border: none;
  border-bottom: none;
  line-height: 64px;
  height: 64px;
}

.nav-menu :deep(.ant-menu-horizontal::after) {
  display: none;
  border: none;
}

.nav-menu :deep(.ant-menu-horizontal:before) {
  display: none;
}

.nav-menu :deep(.ant-menu-item) {
  padding: 0 20px;
  font-size: 14px;
  color: #fff !important;
  border: none;
  margin: 0;
}

.nav-menu :deep(.ant-menu-item::after) {
  display: none !important;
}

.nav-menu :deep(.ant-menu-item:hover) {
  color: #1890ff !important;
  border: none;
}

.nav-menu :deep(.ant-menu-item-selected) {
  color: #1890ff !important;
  border: none;
}

.nav-menu :deep(.ant-menu-item-selected::after) {
  display: none !important;
}

.nav-menu :deep(.anticon) {
  color: #fff;
}

.user-section {
  display: flex;
  gap: 12px;
  padding-right: 20px;
}

.user-section :deep(.ant-btn) {
  color: #fff;
  border-color: #fff;
}

.user-section :deep(.ant-btn-primary) {
  background: #1890ff;
  border-color: #1890ff;
}

.main-content {
  padding-top: 64px;
  margin-top: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  background: #000;
  margin: 0;
  border: none;
}

.main-content::before {
  display: none;
}

.showcase-container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  perspective: 2000px;
  perspective-origin: 50% 50%;
  position: relative;
  z-index: 2;
  background-image: url('@/assets/bg.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.showcase {
  position: relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  transform: translateZ(-100px);
  z-index: 3;
}

.image-container {
  position: absolute;
  left: 50%;
  top: 50%;
  transform-origin: center;
  transition: transform 0.3s ease-out;
  backface-visibility: visible;
  will-change: transform;
}

.image-container img {
  width: 400px;
  height: 600px;
  object-fit: cover;
  border-radius: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
  transform: translate(-50%, -50%);
  opacity: 0.9;
  transition: opacity 0.3s ease-out;
}

.image-container[style*="z: 500"] img {
  opacity: 1;
}

.footer {
  background: #fff;
  padding: 60px 0;
  text-align: center;
}

.contact-section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.contact-title {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 10px;
}

.contact-subtitle {
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 40px;
}

.contact-icons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  max-width: 1000px;
  margin: 0 auto;
}

.contact-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 20px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  transition: transform 0.3s ease;
}

.contact-item:hover {
  transform: translateY(-5px);
}

.qr-code {
  width: 180px;
  height: 180px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.qr-code:hover {
  transform: scale(1.05);
}

.contact-item span {
  font-size: 1.1rem;
  color: #333;
  font-weight: 500;
  text-align: center;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .contact-icons {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }
}

@media (max-width: 640px) {
  .contact-icons {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .qr-code {
    width: 140px;
    height: 140px;
  }
}

.about-section {
  width: 100%;
  background: #fff;
  padding: 80px 0;
  position: relative;
  z-index: 2;
  scroll-margin-top: 64px;
}

.about-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.about-item {
  display: flex;
  align-items: center;
  margin-bottom: 100px;
  gap: 60px;
}

.about-item.reverse {
  flex-direction: row-reverse;
}

.about-image {
  flex: 1;
  max-width: 600px;
}

.about-image img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.about-content {
  flex: 1;
  padding: 20px;
}

.about-content h2 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  color: #333;
  font-weight: bold;
}

.about-content p {
  font-size: 1.2rem;
  line-height: 1.8;
  color: #666;
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .about-item {
    flex-direction: column;
    gap: 30px;
    margin-bottom: 60px;
  }

  .about-item.reverse {
    flex-direction: column;
  }

  .about-image {
    max-width: 100%;
  }

  .about-content {
    padding: 0;
  }

  .about-content h2 {
    font-size: 2rem;
  }

  .about-content p {
    font-size: 1rem;
  }
}

html {
  scroll-behavior: smooth;
}

#contact-section {
  scroll-margin-top: 64px;
}

.notice-modal {
  :deep(.ant-modal-content) {
    border-radius: 8px;
    overflow: hidden;
  }

  :deep(.ant-modal-header) {
    background: #1890ff;
    padding: 16px 24px;
    border-bottom: none;
  }

  :deep(.ant-modal-title) {
    color: white;
    font-size: 18px;
    text-align: center;
  }

  :deep(.ant-modal-close) {
    color: white;
  }

  :deep(.ant-modal-body) {
    padding: 24px;
  }

  :deep(.ant-modal-footer) {
    border-top: none;
    padding: 16px 24px;
    text-align: center;
  }
}

.notice-content {
  h2 {
    color: #1890ff;
    text-align: center;
    margin-bottom: 20px;
    font-size: 20px;
  }

  .notice-text {
    p {
      margin-bottom: 12px;
      line-height: 1.6;
      color: #333;
    }
  }
}

.buy-now-container {
  position: absolute;
  bottom: 80px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  z-index: 10;
}

.buy-now-btn {
  font-size: 1.2rem;
  height: auto;
  padding: 12px 40px;
  border-radius: 30px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
  background: linear-gradient(45deg, #1890ff, #36cfc9);
  border: none;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.buy-now-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
  background: linear-gradient(45deg, #40a9ff, #49d6d0);
}
</style> 